<template>
  <div class="projects-list">
    <Loader :loading="showLoader" />

    <v-toolbar color="#222222" flat dense class="mb-2">
      <v-icon color="#337b52" class="ml-2" size="40" @click="router.go(-1)">
        mdi-arrow-left-bold-circle
      </v-icon>
      <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px !important">
        Art-Invest Filme
      </v-toolbar-title>
    </v-toolbar>

    <transition name="fade" mode="out-in">
      <v-container class="video-grid">
        <v-row justify="center">
          <v-col cols="12" sm="6" md="3" lg="3" xl="3" v-for="video in videos" :key="video.id" class="video-container"
            @click="openPlyr(video)">
            <div class="video-thumbnail">
              <img :src="video.thumbnail" alt="Video Thumbnail" class="thumbnail-image" />
              <div class="overlay">
                <div class="play-icon">&#9658;</div>
                <div class="video-title">{{ video.title }}</div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </transition>

    <!-- Fullscreen Vuetify Dialog with native video -->
    <v-dialog v-model="dialog" fullscreen persistent transition="dialog-bottom-transition">
      <template #default>
        <div class="video-dialog-content">
          <video ref="nativeVideo" :src="selectedVideo.options?.src" :poster="selectedVideo.options?.poster || ''"
            controls playsinline></video>

          <v-btn icon class="close-btn" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { ref, watch, nextTick } from "vue";
import Loader from "@/components/Loader.vue";
import { useRouter } from "vue-router";
import videos from "../services/ArtinvestFixedData/project_videos.js";

export default {
  name: "ProjectFilmsList",
  components: {
    Loader,
  },
  setup() {
    const dialog = ref(false);
    const selectedVideo = ref({});
    const router = useRouter();
    const videosData = ref(videos);

    function openPlyr(video) {
      selectedVideo.value = video;
      dialog.value = true;
    }

    function closeModal() {
      dialog.value = false;
    }

    watch(dialog, async (newVal) => {
      if (newVal) {
        await nextTick();

        setTimeout(() => {
          const videoEl = document.querySelector(".video-dialog-content video");
          if (videoEl) {
            videoEl.muted = false;
            videoEl.play().then(() => {
              videoEl.pause();
            });
            const btns = document.querySelectorAll(".d-tool-item-main");
            if (btns.length > 1) {
              btns[1].textContent = "";
            }
          }
        }, 100);
      }
    });

    return {
      dialog,
      openPlyr,
      closeModal,
      selectedVideo,
      videos: videosData,
      router,
    };
  },
};
</script>

<style scoped>
.video-grid {
  max-width: 1600px;
  margin: 0 auto;
  padding-top: 20px;
}

.video-container {
  padding: 12px;
  cursor: pointer;
}

.video-thumbnail {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  height: 260px;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.play-icon {
  font-size: 48px;
  color: white;
  transition: transform 0.3s ease;
}

.video-title {
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
  color: white;
  font-size: 18px;
  padding: 10px 0;
}

.video-thumbnail:hover .thumbnail-image {
  transform: scale(1.05);
}

.video-thumbnail:hover .overlay {
  background: rgba(0, 0, 0, 0.8);
}

/* Fullscreen dialog player */
.video-dialog-content {
  background-color: black;
  height: 100%;
  width: 100%;
  position: relative;
  padding: 0;
}

.video-dialog-content video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: none;
  outline: none;
  background-color: black;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>